import React from 'react'
import { Svg } from '../../Svg/Svg'
import PropTypes from 'prop-types'

function Select({
  name,
  id,
  value,
  label,
  placeholder,
  isRequired,
  options,
  errorMessage,
  onChange,
  ...otherProps
}) {
  return (
    <div className="mz-form-item mz-form-item--select">
      {label && (
        <label className="mz-form-item__label shrink" htmlFor={id}>
          {label}{isRequired && <span className="mz-form-item__required-star">*</span>}
        </label>
      )}
      <select
        className="mz-form-item__select"
        name={name}
        id={id}
        required={isRequired}
        value={value}
        onChange={onChange}
        {...otherProps}
      >
        {
          placeholder && (
            <option value="" hidden={isRequired} disabled={isRequired}>{placeholder}</option>
          )
        }
        {
          options.map(({value, label, ...rest}) => (
            <option key={value} value={value} {...rest}>{label}</option>
          ))
        }
      </select>
      <div className="mz-form-item__arrow-down">
        <Svg
          type="chevron_small_down"
          size={0.75}
          colour="grey"
        />
      </div>
      {errorMessage && (
        <div className="mz-form-item__error-message">{errorMessage}</div>
      )}
    </div>
  )
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.array.isRequired,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  otherProps: PropTypes.object,
}

Select.defaultProps = {
  options: [],
  value: '',
  placeholder: ''
}

export default Select
